import React, { useEffect } from 'react';

import { useDispatch } from '@app/hooks';

import { bellNotificationsCounterListener, getBellCounter } from '../../slice';

import { Bell } from './Bell';

export const BellNotifications = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(bellNotificationsCounterListener());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getBellCounter());
  }, [dispatch]);

  return <Bell />;
};
